// extracted by mini-css-extract-plugin
module.exports = {"addJobType":"AddJobType_addJobType__2J__d","addJobType__iconWrapper":"AddJobType_addJobType__iconWrapper__BG2vw"};